
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useHistory } from "react-router";
import LayoutWithOutAccountCard from "../Layout/layout-without-card";
import { SUPPORT_CENTER_MENUS } from "../Layout/menu-names";
import { useTranslation } from 'react-i18next';
import { getMenuListSelector } from "../../store/selectors/app.selector";
import { useSelector } from 'react-redux'

export default function SupportCenter() {
    const history = useHistory()
    const {t}=useTranslation()
    const menuConfig = useSelector(getMenuListSelector)['SUPPORT_CENTER'] || {}
  return (
    <LayoutWithOutAccountCard
      breadCumKey="SUPPORT_CENTER"
      keyPath={"SUPPORT_CENTER"}
      showEmptySpace={true}
    >
      <Row>
        {Object.keys(menuConfig).length>0 && SUPPORT_CENTER_MENUS.map((option, index) => (
           <>
           {menuConfig[option.key] && (
          <Col
            onClick={() => history.push(option.link)}
            xs={"auto"}
            sm={"auto"}
            md={"auto"}
            key={index}
            className="account-menu-card"
          >
            <img width={52} height={40} src={option.icon} />
            <h2>{t(option.title)}</h2>
            <span>{t(option.desc)}</span>
          </Col>
           )}
           </>
        ))}
      </Row>
    </LayoutWithOutAccountCard>
  );
}
